import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, Empty, Spin, Tag, Space, FloatButton, Input } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { PageHeader } from 'components/headings';
import useReporteVisitaList from 'hooks/useReporteVisitaList';

const TIPO_LABEL = {
  levantamiento: 'Levantamiento',
  diagnostico: 'Diagnóstico',
  preinspeccion: 'Preinspección',
  cierre: 'Cierre',
  libre: 'Libre',
};

export default function VisitasListPage() {
  const navigate = useNavigate();
  const { rows, loading, setSearch } = useReporteVisitaList();

  return (
    <div style={{ maxWidth: 720, margin: '0 auto', padding: 12 }}>
      <PageHeader title="Mis visitas" subtitle="Reportes de visita en terreno" />
      <Input.Search
        placeholder="Buscar por título…"
        allowClear
        onSearch={setSearch}
        style={{ marginBottom: 12 }}
      />

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin />
        </div>
      ) : rows.length === 0 ? (
        <Empty description="Aún no tenés visitas registradas" />
      ) : (
        <Space direction="vertical" size={10} style={{ width: '100%' }}>
          {rows.map((r) => (
            <Card
              key={r.id}
              size="small"
              hoverable
              onClick={() => navigate(`/specialist/visitas/${r.id}`)}
            >
              <Space style={{ justifyContent: 'space-between', width: '100%' }} align="start">
                <div>
                  <div style={{ fontWeight: 600 }}>{r.titulo}</div>
                  <Space size={6} style={{ marginTop: 4 }}>
                    <Tag>{TIPO_LABEL[r.tipo] || r.tipo}</Tag>
                    <Tag color={r.estado === 'draft' ? 'gold' : 'green'}>
                      {r.estado === 'draft' ? 'Borrador' : 'Cerrada'}
                    </Tag>
                  </Space>
                </div>
              </Space>
            </Card>
          ))}
        </Space>
      )}

      <FloatButton
        icon={<PlusOutlined />}
        type="primary"
        tooltip="Nueva visita"
        onClick={() => navigate('/specialist/visitas/nueva')}
      />
    </div>
  );
}
